export const host = '.';
export const apiVersion = "v1";
export const apiUrl = `${host}/api/${apiVersion}`;
export const tenantId = "common";
export const multipleTenantId = "common";

export const environment = {
  production: true,
  host,
  maxSizeUpload: 524288000,//500MB
  formatDateTime: 'MM/dd/yyyy HH:mm:ss',
  formatDateTimeZone: "yyyy-MM-dd'T'HH:mm:ss x",
  formatDate: 'MM/dd/yyyy',
  formateHoursTime: 'HH:mm:ss',
  apiAuth: apiUrl + '/auth',
  apiUser: apiUrl + '/usermanagement',
  apiCustomView: apiUrl + '/customview',
  apiProfile: apiUrl + '/profilemanagement',
  apiProfileManagement: apiUrl + '/profilemanagement',
  apiCategory: apiUrl + '/categorymanagement',
  apiContactManagement: apiUrl + '/contactmanagement',
  tagManagement: apiUrl + '/tagmanagement',
  locationManagement: apiUrl + '/locationmanagement',
  reasonManagement: apiUrl + '/reasonmanagement',
  seoInfoManagement: apiUrl + '/seomanagement',
  apiProducer: apiUrl + '/producermanagement',
  mediaManagement: apiUrl + '/mediamanagement',
  apiEnquiry: apiUrl + '/EnquiryBasketManagement',
  apiBooking: apiUrl + '/BookingManagement',
  apiActivityLog: apiUrl + '/ActivityLog',
  apiSetting: apiUrl + '/SettingManagement',
  apiBioRewrite: apiUrl + '/BioRewriteManagement',
  //2022-03-21 thoai add start
  apiSeoInfo: apiUrl + '/SeoManagement',
  //2022-03-21 thoai add end

  //2021-11-5 HMTien add start
  maxImageSizeUpload: 3145728, //3mb 02/03/2022 hmtien update
  //2021-11-5 HMTien add end
  //2022-03-21 hmtien add start
  apiOnboardingData: apiUrl + '/OnboardingData',
  //2023-03-21 hmtien add end
  apiTaskStatus: apiUrl + '/TaskManagement',
  apiTaskType: apiUrl + '/TaskManagement',

  apiDashboard: apiUrl + '/Dashboard',
  apiCampaign: apiUrl + '/CampaignManagement',
  apiTaskManagement: apiUrl + '/TaskManagement',
  aipNotification: apiUrl + '/Notification',
  apiOnboarding: apiUrl + '/OnBoarding',
  apiSummaryReport: apiUrl + '/SummaryReport',
  apiPermission: apiUrl + '/PermissionManagement',
  apiRole: apiUrl + '/rolemanagement',
  changeLogUrl: apiUrl + '/ChangeLogManagement',
  apiDiagnosticHistory: apiUrl + '/DiagnosticHistory',

  //2022-02-04 toanpq add start
  apiTaskScriptManagement: apiUrl + '/TaskScriptManagement',
  apiTaskScript: apiUrl + '/TaskScriptManagement',
  apiTaskScriptGroup: apiUrl + '/TaskScriptGroupManagement',
  apiTaskTemplate: apiUrl + '/TaskTemplateManagement',
  //2022-02-04 toanpq add end
  //2022-03-30 hmtien add start
  apiTaskPlanHistory: apiUrl + '/TaskPlanHistoryManagement',
  apiAutoAssignmentReport: apiUrl + '/AutoAssignmentReportManagement',
  //2022-03-30 hmtien add end
  apiSpotlightr: 'https://api.spotlightr.com/api',
  apiTracking: apiUrl + '/Tracking',
  apiAccessLog: apiUrl + '/AccessLogManagement',
  apiAutomateDataState: apiUrl + '/AutomateDataState',
  //2022-04-13 toanpq add datastate table
  apiDatastateManagement: apiUrl + '/DatastateManagement',
  apiBuyer: apiUrl + '/BuyerManagement',

  //2022-04-28 thoai add start
  apiCallEvent: apiUrl + '/CallEventManagement',
  //2022-04-28 thoai add end
  //2022/18/08 thangnpq add start
  apiCallbackMapping: apiUrl + '/CallbackMappingManagement',
  //2022/18/08 thangnpq add end
  apiSupportTicket: apiUrl + '/SupportTicket',
  apiAdminQueries: apiUrl + '/AdminQueries',
  apiQueryHistory: apiUrl + '/QueryHistory',
  apiFontFacing: apiUrl + '/FontFacing',
  apiFileSyncProgress: apiUrl + '/FileSyncProgress',
  apiSystemLogs: apiUrl + '/SystemLogsManagement',
  apiEmailAttachment: apiUrl + '/EmailAttachmentManagement',
  apiPageSpeed: apiUrl + '/PageSpeedManagement',
  apiPhotoProcessQueue: apiUrl + '/PhotoProcessQueueManagement',
  clientId: "7f6b7400-c61f-4196-9c78-5fff9bd6f4ab",
  multipleTenantClientId: "cef1072d-e351-4335-93fc-a6bf99512bc4",
  authority: `https://login.microsoftonline.com/${tenantId}`,
  multipleTenantAuthority: `https://login.microsoftonline.com/${multipleTenantId}`,
  redirectUri: "https://crm1.primas.net/",
  apiMapViewCategory: apiUrl + '/MapViewCategory',
  apiDataFields: apiUrl + '/DataFieldsManagement',
  apiSaleLead: apiUrl + '/SaleLeadManagement',
  apiPageNote: apiUrl + '/UserNoteManagement',
  realtimeNotification: apiUrl + '/RealtimeNotification',
  apiSaleOpportunity: apiUrl + '/SaleOpportunityManagement',
  apiSaleAccount: apiUrl + '/SaleAccountManagement',
  apiApiJob: apiUrl + '/ApiJob',
  apiUserTab: apiUrl + '/UserTabManagement',
  apiDynamicContent: apiUrl + '/DynamicContentManagement',
  apiProfileAdditionDetailManagement: apiUrl + '/ProfileAdditionDetailManagement',
  apiUserUpload: apiUrl + '/FileManagerBusiness',
  apiSaleConvertHistory: apiUrl + '/SaleConvertHistoryManagement',
  apiReminderHistory: apiUrl + '/ReminderHistoryManagement',
  apiUserToken: apiUrl + '/UserTokenManagement',
  apiFrontPageData: apiUrl + '/FrontFacing',
  apiGoogleSearchConsole: apiUrl + '/GoogleSearchConsole',
  titleLead: 'Lead', //Leads => Prospect
  titleAccount: 'Account', //Account => Client
  titleOpportunity: 'Opportunity', //Opportunity => Request for Proposal
  apiMessage: apiUrl + '/MessageManagement',
  apiSMSManagement: apiUrl + '/SMSManagement',
  titleProfile: '',
  title1xService: '1x Service',
  title1xProduct: '1x Product',
  titleTotalValue: 'Estimate Revenue',
  titleProfit: 'Estimate Profit',
  titleEstimate: 'Estimate',
  titleClosedDate: 'Estimated Close Date',
  titleSecondaryCloseDate: 'Contract Date',
  titleAppointmentDate: 'Next Contact Date',
  titleEmployee: 'Performer',
  titleTask: 'Task', //Task => Ticket
  apiClickUp: apiUrl + '/ClickUp',
  apiUserAction: apiUrl + '/UserActionManagement',
  apiStepInFlow: apiUrl + '/StepInFlowManagement',
  apiWorkflowDetail: apiUrl+ '/WorkflowDetailManagement',
  apiCampaignWorkflow: apiUrl + '/CampaignWorkflowManagement',
  apiWorkflowQueue: apiUrl + '/WorkflowQueueManagement',
  apiWorkflowManagement: apiUrl + '/WorkflowManagement',
  apiWorkFlow: apiUrl + '/WorkFlow',
  userApiToken: apiUrl + '/UserApiTokenManagement',
  apiEmployee: apiUrl + '/EmployeeManagement',
  apiScheduleManagement: apiUrl + '/SchedulingManagement',
  apiBandManagement: apiUrl + '/BandManagement',
  apiInteractiveProposal: apiUrl + '/InteractiveProposalManagement',
  apiTimeOffRequestManagement: apiUrl + '/TimeOffRequestManagement',
  apiTimezoneManagement: apiUrl + '/TimezoneManagement',
  apiSchedulingTypeManagement: apiUrl + '/SchedulingTypeManagement',
  apiCustomerManagement: apiUrl + '/CustomerManagement',
  apiVenueManagement: apiUrl + '/VenueManagement',
  apiVenueInquiry: apiUrl + '/VenueInquiryManagement',
  apiOffice: apiUrl + '/CRM/Office',
  apiProjectManagement: apiUrl + '/ProjectManagement',
  apiRevisionVersion: apiUrl + '/RevisionVersion',
  apiDashboardMoneyMaker: apiUrl + '/DashboardMoneyMaker',
  apiContactActivityLog: apiUrl + '/ContactActionLog',
  apiTimeSkip: apiUrl + '/TimeSkipManagement',
  apiIndustry: apiUrl + '/IndustryManagement',
  apiCALIntegration: apiUrl + '/CALIntegration',
  apiReschedule: apiUrl + '/RescheduleManagement',
  apiAutoDialer: apiUrl + '/AutoDialerManagement',
  apiMaintenanceReminder: apiUrl + '/MaintenanceReminder',
  apiShareData: apiUrl + '/Share',
  apiSaleReportDashboard: apiUrl + '/SaleReportDashboard',
  apiDialerGroup: apiUrl + '/DialerGroupManagement'
};
